
// eslint-disable-next-line import/prefer-default-export
export function advertisement(state) {
  return state.advertisement || {};
}



// WEBPACK FOOTER //
// ./src/app/advertisements/store/getters.js